<template>
  <div>
    <div style="background-color: white">
      <van-cell :label="'医院代码:'+ drugDetail.drugCode" :title="drugDetail.drugName" size="large" icon="arrow-left"
                @click="onClick"/>
    </div>
    <div style="width: 100%;margin-top: 8px;background-color: white">
      <van-cell-group>
        <van-cell title="药品图片"/>
        <van-cell>
          <div style="float: left;margin-top: 10px">
            <van-uploader :after-read="afterRead"
                          v-model="fileList"
                          multiple
                          :max-count="6"
                          :beforeDelete="deleteImg"
                          :disabled="status == '待提交'?false:true"
                          :deletable="status == '待提交'?true:false">
              <!--                          :max-size="500 * 1024">-->
              <!--                          @oversize="onOversize">-->
              <template #preview-cover="{ file }">
                <div class="preview-cover van-ellipsis">{{ file.name }}</div>
              </template>
            </van-uploader>
          </div>
        </van-cell>
        <van-cell title="医药药品代码" :value="drugDetail.drugCode"/>
        <van-cell title="规格" :value="drugDetail.specifications"/>
        <van-cell title="生产厂家" :value="drugDetail.manufacturer"/>
        <van-cell title="药品批号" :value="drugDetail.batchNo"/>
        <van-cell title="有效期至" :value="drugDetail.expDate"/>
        <van-cell title="单位" :value="drugDetail.unit"/>
        <van-cell title="入库日期" :value="drugDetail.checkinDate"/>
        <van-cell title="退货数量" :value="drugDetail.qty"/>
        <van-cell title="退货原因"/>
        <van-cell>
          <div style="text-align: left;" v-if="drugDetail.reason !== null">
            <van-button size="small" type="info">{{ drugDetail.reason }}</van-button>
          </div>
        </van-cell>
        <van-cell>
          <van-field
            v-model="drugDetail.remark=='null'?'':drugDetail.remark"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="备注"
          />
        </van-cell>
      </van-cell-group>
    </div>
  </div>

</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";
import {Toast} from 'vant';
import axios from 'axios'

export default {
  name: "orderReturnStep",
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function (val) {
        this.drugId = this.$route.query.drugId;
        this.returnNo = this.$route.query.returnNo;
        this.batchNo = this.$route.query.batchNo;
        this.status = this.$route.query.status;
        //this.initDrugInfo();
        if (val) {
          this.initDrugInfo();
        }
      }
    }
  },
  data() {
    return {
      drugId: '',
      active: 0,
      returnNo: '',
      batchNo: '',
      status: '',
      message: '备注备注备注',
      drugDetail: [],
      fileList: [],
      detailBisId: '',
      stockBisId: ''
    }
  },
  methods: {
    initDrugInfo() {
      //获取该药品信息
      let params = {
        drugId: this.drugId,
        returnNo: this.returnNo,
        batchNo: this.batchNo,
        status: this.status
      };
      api.getDrugDetail(params).then((res) => {
        this.drugDetail = res.result;
        this.detailBisId = res.result.detailId;
        this.stockBisId = res.result.stockId;
        //存放url
        let imgList = res.result.imgList;
        if (imgList.length > 0) {
          for (let i = 0; i < imgList.length; i++) {
            let param = {
              url: imgList[i].url
            };
            this.fileList.push(param);
          }
        }

      })
    },
    onClick() {
      this.$router.go(-1);
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      const params = new FormData();
      params.append("file", file.file);
      params.append("detailBisId", this.detailBisId);
      params.append("stockBisId", this.stockBisId);
      axios.post('/spd/file/imgUpload', params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data.success) {
          this.fileList = [];
          this.initDrugInfo();
          Toast("成功！");
        }
      }).catch(err => {
        alert(err)
      })
    },
    //图片删除功能
    deleteImg(file, detail) {
      // console.log("file:"+file+",detail:"+detail+",name:"+detail.name+",index:"+detail.index);
      return new Promise((resolve, reject) => {
        this.$dialog.confirm({
          message: '确认删除图片？'
        }).then(() => {
          // 存放图片的数组
          let params = {
            fileName: file.url
          }
          api.deleteImg(params).then(res => {
            if (res.success) {
              // this.fileList = [];
              // this.initDrugInfo();
              //this.fileList.value.splice(detail.index, 1)
              this.$toast.success('删除成功')
              return true;
            } else {
              this.$toast.fail('删除失败！')
              return false;
            }
          })
          resolve()
        }).catch(error => {
          this.$toast.fail('已取消')
          reject(error)
        })
      })

      return false;
    },
    // onOversize(file) {
    //   console.log(file);
    //   Toast('文件大小不能超过 500kb');
    // },
  },
  mounted() {
    this.id = this.$route.query.id;
  },
}
</script>

<style scoped>
.g-hd {
  display: inline;
  float: left;
  font-size: 20px;
  font-weight: lighter;
  font-style: normal;
  background-color: white;
  margin-left: 3%;
  overflow: hidden;
}

.van-cell__title {
  text-align: left;
}

.van-cell__value {
  text-align: right;
}

.van-cell__value_reason {
  text-align: left;
}

.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}

</style>



// WEBPACK FOOTER //
// src/spd/returnDrugDetail.vue